// extracted by mini-css-extract-plugin
export default {"tabletImg":"ZP","desktopImg":"aQ","mobileImg":"bQ","backgroundImage":"cQ","content":"eQ","rtbLeft":"fQ","rtbRight":"gQ","imageContainer":"hQ","rtbBox":"iQ","line":"jQ"};
    if(module.hot) {
      // 1715632478448
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  